import { Conditional } from '@cat-ecom/pcc-components';
import ContactYourDealerPopover from 'components/contact-your-dealer/contact-your-dealer-popover/contact-your-dealer-popover';
import { v4 } from 'uuid';
import { availabilityBySourceContentTypes } from './types';
import styles from './availability-by-source-content.module.scss';
import cx from 'classnames';

const AvailabilityBySourceContent = ({
  availStoreList,
  sequence,
  hasAvailabilityMessage,
  locale,
  address,
  availabilityTitle
}: availabilityBySourceContentTypes) => {
  const shouldDisplayAvailabilityTitle =
    hasAvailabilityMessage && sequence !== 4;
  const shouldDisplayContactDealerMessage = sequence === 3 || sequence === 4;

  return (
    <>
      <Conditional test={shouldDisplayAvailabilityTitle}>
        <p className="cat-u-theme-typography-body-sm cat-u-margin-none">
          {availabilityTitle}
        </p>
      </Conditional>

      {availStoreList?.map(
        ({ quantityAvailable, storeName, leadTimeDateRange }) => {
          let messages = `${storeName}`;
          if (leadTimeDateRange) {
            messages += ` (${leadTimeDateRange})`;
          }
          return (
            <p
              className={cx(
                'cat-u-theme-typography-body-sm cat-u-margin-none cat-u-margin-top-sm cat-u-margin-left-sm d-grid',
                styles['p-grid-columns']
              )}
              key={`avail-by-source-content${v4()}`}
            >
              <span
                className={cx(
                  'fw-bolder cat-u-margin-right-sm',
                  styles['span--text-end']
                )}
              >
                {quantityAvailable}:
              </span>
              <Conditional
                test={shouldDisplayContactDealerMessage}
                fallback={messages}
              >
                <ContactYourDealerPopover
                  variant="inline"
                  locale={locale}
                  dealerAddress={address}
                  className="d-inline-block"
                  position="bottom-start"
                  size="md"
                  shouldFitContent
                />
              </Conditional>
            </p>
          );
        }
      )}
    </>
  );
};

export default AvailabilityBySourceContent;
